import ErrorHandler from '../components/ErrorHandler';
import { client } from './Client';

export const getLocations = async () => {
    return client
        .get<Array<Location>>('/locations')
        .then((response) => response.data)
        .catch(ErrorHandler);
};
